module.exports = __webpack_public_path__ + "static/media/img02.6d61c6cd.webp";